angular.
module("dx.webapp.exam").
controller("DxEditExternalToolSettingsController", function editExternalToolSettingsController(
	$rootScope,

	dxLocalize,
	DxExternalToolSettings,

	DX_EXTERNAL_TOOL_PERMISSION_TYPE
) {
	"use strict";

	var self = this;

	self.onOffAlternatives = [
		{displayName: dxLocalize.get("On"), value: true},
		{displayName: dxLocalize.get("Off"), value: false},
	];
	self.TITLE_MAX_LENGTH = DxExternalToolSettings.TITLE_MAX_LENGTH;

	self.settings = new DxExternalToolSettings();
	self.permissionMicrophone = false;
	self.permissionCamera = false;
	self.permissionScreenShare = false;

	self.isLandingPageValid = true;

	self.$onInit = function onInitFn() {
		initializeExternalToolSettings(angular.copy(self.originalSettings));
	};

	self.$onChanges = function onChanges(changes) {
		// Update the component if the external tool settings property passed from the parent component changed.
		if (changes.originalSettings) {
			initializeExternalToolSettings(angular.copy(changes.originalSettings.currentValue));
		}
	};

	function initializeExternalToolSettings(settings) {
		self.settings = settings;
		self.isLandingPageValid = true;
		if (self.externalTool.requiredPermissionsIsEditable) {
			setPermissions(self.settings.getRequiredPermissions(self.externalTool));
		}

		if (self.externalTool.landingPageIsEditable && !settings.landingPageUrl) {
			// If the landing page URL wasn't modified,
			// use the original value stored on the organization-wide external tool.
			self.settings.landingPageUrl = self.externalTool.landingPageUrl;
		}
	}

	function setPermissions(requiredPermissions) {
		self.permissionMicrophone = requiredPermissions.includes(DX_EXTERNAL_TOOL_PERMISSION_TYPE.MICROPHONE);
		self.permissionCamera = requiredPermissions.includes(DX_EXTERNAL_TOOL_PERMISSION_TYPE.CAMERA);
		self.permissionScreenShare = requiredPermissions.includes(DX_EXTERNAL_TOOL_PERMISSION_TYPE.SCREENSHARE);
	}

	function getRequiredPermissions() {
		var requiredPermissions = [];
		if (self.permissionMicrophone) {
			requiredPermissions.push(DX_EXTERNAL_TOOL_PERMISSION_TYPE.MICROPHONE);
		}
		if (self.permissionCamera) {
			requiredPermissions.push(DX_EXTERNAL_TOOL_PERMISSION_TYPE.CAMERA);
		}
		if (self.permissionScreenShare) {
			requiredPermissions.push(DX_EXTERNAL_TOOL_PERMISSION_TYPE.SCREENSHARE);
		}

		return requiredPermissions;
	}

	self.onSubmit = function onSubmit() {
		var formattedSettings = angular.copy(self.settings);

		if (!formattedSettings.isTitleValid()) {
			return; // titles longer than 50 characters are not allowed
		}

		if (self.externalTool.landingPageIsEditable && !self.settings.landingPageUrl) {
			return; // empty landing page input is not allowed
		}

		formattedSettings.setLandingPageUrl(self.settings.landingPageUrl, self.externalTool);

		var requiredPermissions = getRequiredPermissions();
		formattedSettings.setRequiredPermissions(requiredPermissions, self.externalTool);

		formattedSettings.isLandingPageValid(self.externalTool).then(function onSuccess(isValid) {
			self.isLandingPageValid = isValid;
			if (isValid) {
				self.saveExternalToolSettings(formattedSettings);
			} else {
				$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.InvalidLandingPage"));
			}
		}, function onFail() {
			self.isLandingPageValid = false;
			$rootScope.$broadcast("notification:error", dxLocalize.get("SomethingWentWrong"));
		});
	};
});
